import type { ElasticsearchCompleteKeyword } from './api'

export interface GetSearchKeywordsParams {
  category_id?: string
  region_id?: string
}

export interface GetSearchSuggestionKeywordsParams {
  keyword?: string
  region_id?: string
  category_id?: string
}

export enum SearchType {
  KEYWORD = 0,
  BRANCH,
  TAG,
  LOCATION,
}

export interface SearchRecordItem extends ElasticsearchCompleteKeyword {
  image?: string
}
